import { PageLayout } from "../components/PageLayout";
import { Register } from "../features/register/Register";

export const RegisterPage: React.FC = () => {
  return <PageLayout>
    <Register />
  </PageLayout>;
};